<template>
  <div class="ecs-tab-item" :class="{ active: active }" @click="emitChange">
    <slot />
    <span class="badge badge-info badge-pill" v-if="count > 0">
      {{ count }}
    </span>
  </div>
</template>
<script>
export default {
  name: "TabItem",
  props: {
    tabItemKey: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    emitChange() {
      this.$emit("click", this.tabItemKey);
    },
  },
};
</script>
<style lang="scss" scoped>
.ecs-tab-item {
  padding: 8px 42px;
  gap: 10px;
  cursor: pointer;
  position: relative;

  &.active {
    border-radius: 10px;
    background: #fff;
    font-weight: bold;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.14);
  }
  .badge {
    top: 50%;
    transform: translateY(-50%);
    right: 10%;
    position: absolute;
    border-radius: 1rem;
  }
}
</style>
